var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / KM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-KM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFCB49",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DC1D34",
    mask: "url(#mask-2)",
    x: 0,
    y: 9.33333333,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#4985D4",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#4BA343",
    mask: "url(#mask-2)",
    points: "0 20 13.3333333 10 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,6 C5.67890708,6 6.01424554,6.04382251 6.33409467,6.12621352 C4.60822606,6.56991294 3.33333333,8.13607289 3.33333333,10 C3.33333333,11.8639271 4.60822606,13.4300871 6.33357681,13.8740452 C6.01424554,13.9561775 5.67890708,14 5.33333333,14 C3.12419433,14 1.33333333,12.209139 1.33333333,10 C1.33333333,7.790861 3.12419433,6 5.33333333,6 Z M7.33333333,12 C7.70152317,12 8,12.2984768 8,12.6666667 C8,13.0348565 7.70152317,13.3333333 7.33333333,13.3333333 C6.9651435,13.3333333 6.66666667,13.0348565 6.66666667,12.6666667 C6.66666667,12.2984768 6.9651435,12 7.33333333,12 Z M7.33333333,9.33333333 C7.70152317,9.33333333 8,9.63181017 8,10 C8,10.3681898 7.70152317,10.6666667 7.33333333,10.6666667 C6.9651435,10.6666667 6.66666667,10.3681898 6.66666667,10 C6.66666667,9.63181017 6.9651435,9.33333333 7.33333333,9.33333333 Z M7.33333333,6.66666667 C7.70152317,6.66666667 8,6.9651435 8,7.33333333 C8,7.70152317 7.70152317,8 7.33333333,8 C6.9651435,8 6.66666667,7.70152317 6.66666667,7.33333333 C6.66666667,6.9651435 6.9651435,6.66666667 7.33333333,6.66666667 Z",
    id: "Oval-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/KM.c3d7a716fb955d2a1103072a7f841baf.svg";
export { ForwardRef as ReactComponent };